import { render, staticRenderFns } from "./FeaturedPrimaryFilterList.vue?vue&type=template&id=42abb8a4&"
import script from "./FeaturedPrimaryFilterList.vue?vue&type=script&lang=js&"
export * from "./FeaturedPrimaryFilterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports